import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, ClipboardList } from 'lucide-react';

export const labDirectorNav = (isHovered, styles) => (
     <>
          <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <Home size={20} />
               {isHovered && <span>Dashboard</span>}
          </NavLink>
          {/* http://localhost:3000/admin-evaluations */}
          <NavLink to="/admin-evaluations" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <ClipboardList size={20} />
               {isHovered && <span>Consultants Evaluations</span>}
          </NavLink>
          <NavLink to="/admin-renewals" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <ClipboardList size={20} />
               {isHovered && <span>Consultants Renewals</span>}
          </NavLink>

          <NavLink to="/attendance" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <CalendarCheck size={20} />
               {isHovered && <span>Attendance</span>}
          </NavLink>
          {/* /employee-attendance-details */}
          <NavLink to="/employee-attendance-details" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <CalendarCheck size={20} />
               {isHovered && <span>Employee Attendance</span>}
          </NavLink>



     </>
);